<template>
  <div class="column is-12 is-paddingless">
    <div class="search-desktop">
      <span
        class="icon is-right"
        @click="search()"
      >
        <i class="far fa-search" />
      </span>
      <input
        v-model="value"
        class="input-search"
        type="text"
        placeholder="Search"
        @keydown.enter="search()"
      >
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Search',
    data () {
      return {
        value: ''
      }
    },
    methods: {
      search () {
        this.$emit('search', this.value)
      }
    }
  }
</script>
